export const OptionsIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <g clip-path="url(#clip0_2059_4204)">
            <path d="M7.99991 4.28644C8.92038 4.28644 9.66656 3.54025 9.66656 2.61978C9.66656 1.69931 8.92038 0.953125 7.99991 0.953125C7.07944 0.953125 6.33325 1.69931 6.33325 2.61978C6.33325 3.54025 7.07944 4.28644 7.99991 4.28644Z" fill="white"/>
            <path d="M7.99991 10.6198C8.92038 10.6198 9.66656 9.87362 9.66656 8.95316C9.66656 8.03269 8.92038 7.2865 7.99991 7.2865C7.07944 7.2865 6.33325 8.03269 6.33325 8.95316C6.33325 9.87362 7.07944 10.6198 7.99991 10.6198Z" fill="white"/>
            <path d="M7.99991 16.9531C8.92038 16.9531 9.66656 16.2069 9.66656 15.2865C9.66656 14.366 8.92038 13.6198 7.99991 13.6198C7.07944 13.6198 6.33325 14.366 6.33325 15.2865C6.33325 16.2069 7.07944 16.9531 7.99991 16.9531Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_2059_4204">
            <rect width="16" height="16" fill="white" transform="translate(0 0.953125)"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
